import * as React from 'react';
import { Copy } from 'lucide-react';
import { Button, Textarea } from '@shigo-ui/ui';
import { cn } from '@shigo-ui/ui/cn';

import { copyToClipboard } from '../../../../../lib/clipboard';
import { dashboardT } from '../../../../../lib/messages';

type TargetingTextareaProps = Omit<React.ComponentProps<typeof Textarea>, 'value'> & {
  copyLabel: string;
  value: string;
};

export const TargetingTextarea = React.forwardRef<HTMLTextAreaElement, TargetingTextareaProps>(
  ({ className, copyLabel, value, ...props }, ref) => (
    <div className="group relative">
      <Textarea ref={ref} className={cn('min-h-28 pr-11', className)} value={value} {...props} />
      <Button
        type="button"
        variant="secondary"
        size="icon"
        className="pointer-events-none absolute top-2 right-2 h-7 w-7 rounded-md opacity-0 shadow-sm transition-opacity group-hover:pointer-events-auto group-hover:opacity-100 focus-visible:pointer-events-auto focus-visible:opacity-100"
        aria-label={dashboardT('targeting.copyText', { name: copyLabel })}
        onClick={() => {
          void copyToClipboard(value, {
            successMessage: dashboardT('targeting.textCopied'),
            errorMessage: dashboardT('targeting.textCopyError'),
          });
        }}
      >
        <Copy className="h-3.5 w-3.5" aria-hidden="true" />
      </Button>
    </div>
  ),
);

TargetingTextarea.displayName = 'TargetingTextarea';
